/**
 * Funding Callback Atom
 *
 * Jotai atom that stores per-FundingOption outcome callbacks.
 * Used as a lightweight alternative to the pub/sub event system for flows
 * where passing an event ID through every URL layer is costly (many files).
 *
 * Lifecycle:
 *  1. useFundingNavigation sets the callback before pushing the funding route.
 *  2. The terminal success screen reads the callback via useFundingCallback and
 *     calls invokeCallback({ success: true }).
 *  3. invokeCallback clears the stored callback to prevent double-firing.
 */

import { FundingOption } from '@varo/graphql-schema-types';
import { atom } from 'jotai';

export type FundingOutcome = {
  success: boolean;
};

export type FundingCallback = (outcome: FundingOutcome) => void;

export const fundingCallbackAtom = atom<
  Partial<Record<FundingOption, FundingCallback>>
>({});
